<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import vConsole from "vconsole";
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    // 创建 vConsole 对象
    // new vConsole();
  },
};
</script>
